import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';

// The MUI pickers' dayjs adapter - every LocalizationProvider in the app uses this one, and lint
// rejects the plain AdapterDayjs.
//
// The backend's US date format is MM\/DD\/YYYY: moment's backslash escapes (see shared/dayjs.ts).
// The plain adapter does not know them and keeps every backslash as a separator, so a picker showed
// "MM\/DD\/YYYY" as its placeholder and "03\/09\/2026" as its value. This one reads every format
// without backslashes, as moment and shared/dayjs do.
const withoutBackslashes = (format: string) =>
    typeof format === 'string' ? format.replace(/\\/g, '') : format;

export class AppAdapterDayjs extends AdapterDayjs {
    constructor(...args: ConstructorParameters<typeof AdapterDayjs>) {
        super(...args);
        // The plain adapter sets its methods on the instance, so they are wrapped here, not overridden.
        const { expandFormat, parse, formatByString } = this;
        this.expandFormat = (format) => expandFormat(withoutBackslashes(format));
        this.parse = (value, format) => parse(value, withoutBackslashes(format));
        this.formatByString = (value, format) => formatByString(value, withoutBackslashes(format));
    }
}
